import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/images/logo.png';
import './WelcomePopup.css';

const POPUP_DELAY_MS = 1 * 60 * 1000; // 1 minute

export default function WelcomePopup() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const lastClosed = localStorage.getItem('popup_closed_at');
    const now = Date.now();
    const shouldShow = !lastClosed || (now - parseInt(lastClosed)) > POPUP_DELAY_MS;

    if (shouldShow) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const close = () => {
    localStorage.setItem('popup_closed_at', Date.now().toString());
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="wp-overlay" onClick={close}>
      <div className="wp-modal" onClick={(e) => e.stopPropagation()}>

        {/* Close */}
        <button className="wp-close" onClick={close} aria-label="Close">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        {/* Top image banner */}
        <div className="wp-banner">
          <img src={logo} alt="Ashoka IAS Academy" className="wp-banner__logo" />
          <div className="wp-banner__badge">
            <span className="wp-banner__dot" />
            Admissions Open 2026–27
          </div>
        </div>

        {/* Content */}
        <div className="wp-body">
          <h2 className="wp-title">
            Begin Your Civil Services<br />
            <span className="wp-title--gold">Journey Today</span>
          </h2>
          <p className="wp-desc">
            Join Ashoka IAS Academy - Assam & North-East's trusted coaching institution for
            <strong> UPSC, APSC</strong> and other government competitive examinations.
          </p>

          {/* Stats row */}
          <div className="wp-stats">
            <div className="wp-stat">
              <strong>500+</strong>
              <span>Students</span>
            </div>
            <div className="wp-stat-sep" />
            <div className="wp-stat">
              <strong>150+</strong>
              <span>Selections</span>
            </div>
            <div className="wp-stat-sep" />
            <div className="wp-stat">
              <strong>ACS 9</strong>
              <span>Top Rank</span>
            </div>
            <div className="wp-stat-sep" />
            <div className="wp-stat">
              <strong>2021</strong>
              <span>Est. Year</span>
            </div>
          </div>

          {/* CTAs */}
          <div className="wp-actions">
            <Link to="/contact" className="wp-btn wp-btn--primary" onClick={close}>
              Apply Now →
            </Link>
            <a
              href="https://wa.me/918822823003"
              target="_blank"
              rel="noreferrer"
              className="wp-btn wp-btn--wa"
              onClick={close}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z" />
              </svg>
              WhatsApp
            </a>
          </div>

          <button className="wp-skip" onClick={close}>
            Maybe later
          </button>
        </div>

      </div>
    </div>
  );
}
